// extracted by mini-css-extract-plugin
module.exports = {"Container":"Menu_Container__VprCx","LinkAction":"Menu_LinkAction__C0PSW","ButtonRecordWidget":"Menu_ButtonRecordWidget__KxnDS"};